//  Needs to export a checks and a modify lists that the content will be passed through

// todo , in same way as post.js

/**
 *Capitalizes the first word in a string
 * @param {string} str The string to manipulate
 */
export const ucFirst = (str = '') => {
  const stringArray = str.split(' ');
  const manipulatedArray = stringArray.map((w = '') => {
    const fLetter = w[0].toUpperCase();
    return `${fLetter}${w.substr(1)}`;
  });
  const manipulatedString = manipulatedArray.join(' ');
  return manipulatedString;
};
